import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={52.463}
      height={52.463}
      viewBox="0 0 52.463 52.463"
      {...props}
    >
      <g data-name="Group 702">
        <g fill="#fff" data-name="02-shop">
          <path
            data-name="Path 8278"
            d="M52.454 17.488H0v2.186a4.372 4.372 0 004.372 4.372h6.558a4.372 4.372 0 004.37-4.372 4.372 4.372 0 004.372 4.372h13.117a4.372 4.372 0 004.372-4.372 4.372 4.372 0 004.372 4.372h6.558a4.372 4.372 0 004.372-4.372v-2.186z"
          />
          <path
            data-name="Path 8279"
            d="M51.926 15.3L48.007 1.585A2.186 2.186 0 0045.905 0H35.893l3.06 15.3z"
          />
          <path
            data-name="Path 8280"
            d="M16.57 0H6.554a2.186 2.186 0 00-2.1 1.585L.537 15.3H13.51z"
          />
          <path data-name="Path 8281" d="M31.435 0H21.028l-3.06 15.3h16.527z" />
          <path
            data-name="Path 8282"
            d="M41.533 26.232a6.532 6.532 0 01-4.372-1.674 6.532 6.532 0 01-4.375 1.674H19.674a6.532 6.532 0 01-4.372-1.674 6.532 6.532 0 01-4.372 1.674H4.372a6.515 6.515 0 01-2.186-.383v24.428a2.186 2.186 0 002.186 2.186h4.372V32.79a2.186 2.186 0 012.186-2.186h10.93a2.186 2.186 0 012.186 2.186v19.673h24.045a2.186 2.186 0 002.186-2.186V25.849a6.515 6.515 0 01-2.186.383zm2.186 13.116a2.186 2.186 0 01-2.186 2.186h-10.93a2.186 2.186 0 01-2.186-2.186V32.79a2.186 2.186 0 012.186-2.186h10.93a2.186 2.186 0 012.186 2.186z"
          />
        </g>
        <g data-name="light-bulb (6)" fill="#fff">
          <g data-name="Group 327">
            <path
              data-name="Path 7444"
              d="M14.707 50.418a.584.584 0 00.58.584h2.336a.584.584 0 100-1.168h-2.336a.584.584 0 00-.58.584z"
            />
            <path
              data-name="Path 7445"
              d="M14.707 49.25a.584.584 0 00.58.584h2.336a.584.584 0 100-1.168h-2.336a.584.584 0 00-.58.584z"
            />
            <path
              data-name="Path 7446"
              d="M18.207 48.082v-.584h-3.5v.584a.584.584 0 00.58.584h2.336a.584.584 0 00.584-.584z"
            />
          </g>
          <g data-name="Group 328">
            <path
              data-name="Path 7447"
              d="M16.455 52.17a1.168 1.168 0 001.168-1.168h-2.336a1.168 1.168 0 001.168 1.168z"
            />
            <path
              data-name="Path 7448"
              d="M18.791 46.914v-.685a1.161 1.161 0 01.441-.894 4.38 4.38 0 10-5.531.018 1.164 1.164 0 01.418.909v.652a.586.586 0 00.584.584h3.5a.586.586 0 00.588-.584z"
            />
          </g>
          <g data-name="Group 329">
            <path
              data-name="Path 7449"
              d="M13.518 45.581a.876.876 0 01.307.681v.652a.876.876 0 00.584.822v.346a.872.872 0 00.23.58.863.863 0 000 1.168.867.867 0 00.38 1.414 1.455 1.455 0 002.87 0 .867.867 0 00.383-1.414.863.863 0 000-1.168.872.872 0 00.228-.584v-.346a.876.876 0 00.584-.822v-.685a.87.87 0 01.333-.668 4.672 4.672 0 00-2.958-8.283c-.076 0-.153 0-.23.006a4.726 4.726 0 00-4.445 4.637 4.645 4.645 0 001.734 3.664zm4.4 2.5a.292.292 0 01-.293.293h-2.337a.292.292 0 01-.292-.292v-.292h2.919zm0 1.168a.292.292 0 01-.293.293h-2.337a.292.292 0 110-.584h2.337a.292.292 0 01.29.292zm-1.463 2.629a.878.878 0 01-.826-.584h1.652a.878.878 0 01-.826.584zm1.17-1.168h-2.337a.292.292 0 110-.584h2.337a.292.292 0 010 .584zm-1.369-12.843a4.086 4.086 0 012.791 7.242 1.451 1.451 0 00-.547 1.121v.684a.292.292 0 01-.292.292h-3.5a.292.292 0 01-.292-.292v-.652a1.449 1.449 0 00-.526-1.137 4.063 4.063 0 01-1.518-3.2 4.134 4.134 0 013.884-4.058z"
            />
            <path
              data-name="Path 7450"
              d="M16.455 34.942a.292.292 0 01.292.292v1.168a.292.292 0 01-.584 0v-1.168a.292.292 0 01.292-.292z"
            />
            <path
              data-name="Path 7451"
              d="M19.813 35.839a.292.292 0 01.253.438l-.584 1.014a.292.292 0 01-.508-.289l.586-1.014a.291.291 0 01.253-.149z"
            />
            <path
              data-name="Path 7452"
              d="M22.271 38.3a.292.292 0 01.146.545l-1.011.584a.292.292 0 01-.3-.5l1.019-.59a.289.289 0 01.146-.039z"
            />
            <path
              data-name="Path 7453"
              d="M22.003 41.658h1.168a.292.292 0 110 .584h-1.168a.292.292 0 010-.584z"
            />
            <path
              data-name="Path 7454"
              d="M21.265 44.432a.291.291 0 01.146.039l1.006.584a.292.292 0 11-.288.508l-1.015-.586a.292.292 0 01.146-.545z"
            />
            <path
              data-name="Path 7455"
              d="M11.65 44.432a.292.292 0 01.146.545l-1.011.584a.292.292 0 11-.3-.5l1.019-.59a.291.291 0 01.146-.039z"
            />
            <path
              data-name="Path 7456"
              d="M9.739 41.658h1.168a.292.292 0 110 .584H9.739a.292.292 0 110-.584z"
            />
            <path
              data-name="Path 7457"
              d="M10.645 38.3a.291.291 0 01.146.039l1.006.584a.292.292 0 11-.288.508l-1.015-.586a.292.292 0 01.146-.545z"
            />
            <path
              data-name="Path 7458"
              d="M13.098 35.839a.292.292 0 01.253.146l.584 1.014a.292.292 0 11-.5.3l-.59-1.019a.292.292 0 01.253-.441z"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default SvgComponent
